import { useEffect } from 'react';
import useAuth from '../context/authContext';
import { useGlobalContext } from '../context/globalContext';
import { parseCookies } from '../utils/helperFunctions';

function readSiteCookie(): string {
  const raw = parseCookies(document.cookie).site;
  if (!raw) {
    return '';
  }
  try {
    return decodeURIComponent(raw);
  } catch {
    return raw;
  }
}

/** Hydrate active site from cookie or `/me` when the MC session has no `site` cookie yet. */
export function useSiteBootstrap(): void {
  const { user, hydrated } = useAuth();
  const { siteName, setSiteName } = useGlobalContext();

  useEffect(() => {
    if (!hydrated || siteName.length > 0) {
      return;
    }

    const cookieSite = readSiteCookie();
    if (cookieSite) {
      setSiteName(cookieSite);
      return;
    }

    if (!user) {
      return;
    }

    if (user.site) {
      setSiteName(user.site);
      return;
    }

    if (user.sites?.length) {
      setSiteName(user.sites[0]);
    }
  }, [hydrated, siteName, setSiteName, user]);
}
